import AsistenciaABM from "components/AsistenciaABM";
import Card from "components/card";

/**
 * Antes esta página metía su única tarjeta dentro de una grilla de 2 columnas,
 * así que ocupaba media pantalla y dejaba el resto vacío en escritorio.
 */
const EventosPage = () => {
  return (
    <Card extra="flex w-full select-none flex-col p-5 text-left sm:p-6">
      <AsistenciaABM />
    </Card>
  );
};

export default EventosPage;
